import Loadable from 'react-loadable';
import Loading from './Loading';

export default opts => {
  return Loadable(
    Object.assign(
      {
        loading: Loading,
        delay: 200,
        timeout: 500,
      },
      opts
    )
  );
};



// WEBPACK FOOTER //
// ./src/common/Loadable/index.js